import { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { requestPOST } from 'src/utils/baseAPI';
import moment from 'moment';
import { useIntl } from 'react-intl';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const RenderChartVehicleInOut = ({ fromDateToDate, selectedBranch }) => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [loading, setLoading] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        console.log(fromDateToDate)
        // Lấy dữ liệu xe vào ra từ API searchinout
        const res = await requestPOST('api/v1/eventvehicleinouts/searchinout', {
          timeFrom: fromDateToDate?.fromDate.clone().add(7, 'hours'),
          timeTo: fromDateToDate?.toDate.clone().add(7, 'hours'),
          branchId: selectedBranch ?? null,
          pageNumber: 1,
          pageSize: 1000, // Lấy nhiều dữ liệu để tính toán
        });

        const data = res?.data ?? [];
        
        // Nhóm dữ liệu theo ngày và loại (IN/OUT)
        const groupedByDate = {};
        
        data.forEach(record => {
          const eventDate = record.timeEvent ? moment(record.timeEvent).format('DD/MM/YYYY') : null;
          
          if (eventDate) {
            if (!groupedByDate[eventDate]) {
              groupedByDate[eventDate] = { vehicleIn: 0, vehicleOut: 0 };
            }
            
            // Đếm xe vào và xe ra dựa trên field type
            if (record.type === 'IN') {
              groupedByDate[eventDate].vehicleIn++;
            } else if (record.type === 'OUT') {
              groupedByDate[eventDate].vehicleOut++;
            }
          }
        });

        // Chuyển đổi thành dữ liệu cho biểu đồ
        const dates = Object.keys(groupedByDate).sort((a, b) => 
          moment(a, 'DD/MM/YYYY').diff(moment(b, 'DD/MM/YYYY'))
        );
        
        const vehicleInData = dates.map(date => groupedByDate[date].vehicleIn);
        const vehicleOutData = dates.map(date => groupedByDate[date].vehicleOut);

        setChartData({
          labels: dates,
          datasets: [
            {
              label: 'Xe vào',
              data: vehicleInData,
              backgroundColor: 'rgba(40, 167, 69, 0.8)',
              borderColor: 'rgba(40, 167, 69, 1)',
              borderWidth: 1,
            },
            {
              label: 'Xe ra',
              data: vehicleOutData,
              backgroundColor: 'rgba(220, 53, 69, 0.8)',
              borderColor: 'rgba(220, 53, 69, 1)',
              borderWidth: 1,
            },
          ],
        });

        setLoading(false);
      } catch (error) {
        console.error('Error fetching vehicle in/out data:', error);
        setLoading(false);
      }
    };

    if (fromDateToDate?.fromDate && fromDateToDate?.toDate) {
      fetchData();
    }
  }, [fromDateToDate, selectedBranch]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: `Biểu đồ lịch sử xe vào ra theo ngày (${fromDateToDate?.fromDate?.format('DD/MM/YYYY')} - ${fromDateToDate?.toDate?.format('DD/MM/YYYY')})`,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return value + ' lượt';
          }
        }
      },
      x: {
        title: {
          display: true,
          text: 'Ngày'
        }
      }
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
  };

  return (
    <div className="card card-xl-stretch mb-xl-5">
      <div className="card-header min-h-50px">
        <h3 className="card-title fw-bold text-primary">Lịch sử xe vào ra</h3>
      </div>
      <div className="card-body">
        {loading ? (
          <div className="d-flex justify-content-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <Bar options={options} data={chartData} />
        )}
      </div>
    </div>
  );
};

export default RenderChartVehicleInOut; 